import React, { useEffect, useState } from 'react';
import LeaderBoardList from '../../../component/EliteGame/LeaderBoardList';
import { getDailyLeaderBoard } from '../../../api/eliteGameApi';

const DailyLeaderBoard = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchData(page);
  }, [page]);

  const fetchData = async (pageNum) => {
    const response = await getDailyLeaderBoard({ page: pageNum, limit: 10 });
    setData(response);
  };

  const handlePagination = (newPage) => {
    setPage(newPage);
  };

  return (
    <LeaderBoardList
      data={data}
      page={page}
      header="Daily LeaderBoard"
      handlePagination={handlePagination}
    />
  );
};

export default DailyLeaderBoard;
